<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot></slot>
      </span>
    </template>
    <v-card>
      <v-card-title>
        Selecione os contatos para envio
        <v-spacer />
        <v-btn icon @click="cancelar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <template v-if="loading">
          <v-skeleton-loader type="list-item-two-line" />
          <v-skeleton-loader type="list-item-two-line" />
        </template>
        <v-list v-else-if="contatos.length > 0">
          <v-list-item-group v-model="contatosSelecionados" multiple>
            <v-list-item
              v-for="(contato, i) in contatos"
              :key="`contato-${i}`"
              :value="contato"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-action>
                  <v-checkbox :input-value="active" @click="toggle" />
                </v-list-item-action>
                <list-item-contato :contato="contato" />
                <v-list-item-action>
                  <v-btn icon @click.stop="detalhes(contato)">
                    <v-icon>mdi-card-account-details-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <p v-else class="px-4 text-center subtitle-1">
          <i>Nenhum contato disponível</i>
        </p>
        <v-combobox
          v-model="emailsAdicionais"
          v-touch="emailsAdicionais"
          deletable-chips
          small-chips
          clearable
          multiple
          :delimiters="[' ']"
          :error-messages="erroEmail"
          :disabled="loading"
          label="Emails adicionais"
          class="px-4"
          hint="Aperte ENTER, ESPAÇO ou TAB para cada email informado"
          persistent-hint
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed @click="cancelar()">CANCELAR</v-btn>
        <v-btn
          depressed
          color="primary"
          @click="confirmar()"
          :disabled="formDisabled || loading"
          >CONFIRMAR</v-btn
        >
      </v-card-actions>
    </v-card>
    <contato-detalhe-dialog />
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { email } from "vuelidate/lib/validators";
import ListItemContato from "./ListItemContato";
import ContatoDetalheDialog from "./ContatoDetalheDialog";
export default {
  components: { ListItemContato, ContatoDetalheDialog },
  mixins: [validationMixin],
  props: ["tipoEntidade", "idEntidade", "tipoPadrao"],
  data() {
    return {
      dialog: false,
      loading: true,
      contatos: [],
      contatosSelecionados: [],
      emailsAdicionais: [],
    };
  },
  validations: {
    emailsAdicionais: {
      $each: {
        email,
      },
    },
  },
  computed: {
    erroEmail() {
      const errors = [];
      if (!this.$v.emailsAdicionais.$dirty) return errors;
      this.$v.emailsAdicionais.$invalid &&
        errors.push("Você precisa informar emails válidos");
      return errors;
    },
    formDisabled() {
      return (
        this.$v.$invalid ||
        (this.contatosSelecionados.length === 0 &&
          this.emailsAdicionais.length === 0)
      );
    },
  },
  mounted() {
    this.carregarContatos();
  },
  methods: {
    confirmar() {
      const emails = this.emailsAdicionais;
      this.contatosSelecionados.map((contatos) => {
        contatos.emails.map((email) => emails.push(email.email));
      });
      this.$emit("confirmar", emails);
      this.cancelar();
    },
    cancelar() {
      this.dialog = false;
      this.contatosSelecionados = [];
      this.emailsAdicionais = [];
    },
    async carregarContatos() {
      this.loading = true;
      try {
        const contatos = await this.$store.dispatch("contato/listar", {
          tipo_entidade: this.tipoEntidade,
          id_entidade: this.idEntidade,
        });
        this.contatos = contatos.filter((contato) => contato.emails.length > 0);

        this.contatos.map(
          (contato) =>
            contato.tipos.includes(this.tipoPadrao) &&
            this.contatosSelecionados.push(contato)
        );
      } catch (error) {
        console.log(error);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de contatos",
        });
      }
      this.loading = false;
    },
    detalhes(contato) {
      this.$store.commit("contato/setContatoAtivo", contato);
    },
  },
};
</script>
